import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { lightBlue, grey } from '@material-ui/core/colors';

const useStyles = (value, open) => makeStyles(theme => ({
    root: {
        cursor: 'pointer',
        borderBottomColor: open ? theme.palette.primary.main : (value ? grey['900'] : lightBlue['100'])
    },
    disabled: {
        cursor: 'pointer',
        borderBottomColor: '#b4b5bd',
        pointerEvents: 'none',
    },
    isOpenNotValue: {
        position: 'relative',
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '15px',
        letterSpacing: 'normal',
        color: '#237fc2',
        marginTop: 5,
    },
    isOpen: {
        position: 'relative',
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '15px',
        letterSpacing: 'normal',
        marginTop: 5,
        color: theme.palette.text.secondary,
    },
    notOpen: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: "24px",
        letterSpacing: '0.13px',
        color: '#88898c',
        bottom: 0,
        marginTop: 16,
    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
        marginTop: 6
    },
    arrowIcon: {
        margin: 'auto',
        marginRight: 8
    }
}));

export default function SelectBox({ children, value, label, open, handleClick, disabled, required, header, filter, bgcolor }) {
    const classes = useStyles(value, open)();

    const shouldOpen = open && !disabled;
    return (
        <Box borderRadius='2px'>
            <Box position='relative'
                borderBottom={open ? 2 : 1}
                className={disabled ? classes.disabled : classes.root}
                height='55px'
                bgcolor={bgcolor}
                display='flex'
                width='100%'
                onClick={handleClick}>
                <Box flexGrow={1} pl="25px">
                    <Typography className={open ? classes.isOpenNotValue : (value !== "" ? classes.isOpen : classes.notOpen)}>
                        {label}
                        {
                            required && <sup style={{ fontSize: open || value !== "" ? 'smaller' : 'medium', position: 'absolute', marginLeft: 2 }}>*</sup>
                        }
                    </Typography>
                    <Typography className={classes.TextValue}>{value}</Typography>
                </Box>
                {
                    shouldOpen ?
                        (
                            <ArrowDropUp
                                fontSize="large"
                                color={disabled ? 'disabled' : 'primary'}
                                className={classes.arrowIcon}
                            />
                        ) : (
                            <ArrowDropDown
                                fontSize="large"
                                color={disabled ? 'disabled' : 'primary'}
                                className={classes.arrowIcon}
                            />
                        )
                }
            </Box>
            <Collapse in={shouldOpen} timeout="auto" unmountOnExit>
                <Box width='100%'>
                    {filter}
                    {header}
                    <Box bgcolor='background.paper' style={{ maxHeight: 200, overflow: 'auto' }}>
                        <List component="nav" disablePadding>
                            {children}
                        </List>
                    </Box>
                </Box>
            </Collapse>
        </Box >
    );
}

SelectBox.propTypes = {
    bgcolor: PropTypes.string
};

SelectBox.defaultProps = {
    bgcolor: 'background.paper'
};
